import {
  FormField,
  SfAmountInputFormField,
  SfInputFormField,
  SfNumberInputFormField,
  SfSelectFormField,
  SfTextAreaFormField,
} from 'ngx-smart-form';
import { Gravame } from '../gravame';
import { Property } from '../property';
import { PropertyType } from '../property-type';

export const getPropertyFields = (property?: Property) => {
  const fields: FormField<Property>[][] = [
    [
      new SfSelectFormField<Property>({
        formControlName: 'tipo',
        label: 'Tipo immobile',
        options: [
          { value: PropertyType.ABITATIVO, view: 'ABITATIVO' },
          { value: PropertyType.COMMERCIALE, view: 'COMMERCIALE' },
          { value: PropertyType.INDUSTRIALE, view: 'INDUSTRIALE' },
          { value: PropertyType.ALTRO, view: 'ALTRO' },
        ],
        required: true,
        toggleIcon: 'test',
      }),
      new SfInputFormField<Property>({
        formControlName: 'comune',
        label: 'Località',
        required: true,
      }),
    ],
    [
      new SfAmountInputFormField<Property>({
        formControlName: 'valoreStimato',
        label: 'Rendita catastale',
        required: true,
        currency: '€',
      }),
      new SfAmountInputFormField({
        formControlName: 'percentuale',
        label: 'Percentuale di proprietà',
        required: true,
        currency: '%',
        decimals: 0,
      }),
    ],
    [
      new SfSelectFormField<Property>({
        formControlName: 'gravame',
        label: 'Tipo di gravame',
        options: [
          { value: Gravame.IPOTECHE_VOLONTARIE, view: 'IPOTECHE VOLONTARIE' },
          { value: Gravame.SERVITU, view: 'SERVITU’' },
          { value: Gravame.ALTRO, view: 'ALTRO' },
          {
            value: Gravame.IPOTECHE_PIGNORAMENTI,
            view: 'IPOTECHE LEGALI E PIGNORAMENTI',
          },
          { value: Gravame.NESSUNO, view: 'NESSUNO' },
        ],
        required: true,
      }),
      new SfAmountInputFormField({
        formControlName: 'debito',
        label: 'Debito residuo',
        required: true,
        decimals: 2,
        currency: '€',
      }),
    ],
    [
      new SfTextAreaFormField({
        formControlName: 'note',
        label: 'Note',
      }),
    ],
  ];

  fields.forEach((row) =>
    row.forEach(
      (field) =>
        (field.value =
          field.value !== undefined
            ? field.value
            : property?.[field.formControlName])
    )
  );

  return fields;
};
